module.exports = __webpack_public_path__ + "img/paypal.e6b9aef8.svg";